module.exports = __webpack_public_path__ + "static/media/happyActive.596b50f8.svg";